import React from "react";
import PropTypes from "prop-types";

import { Styles } from "./ShipnowLogo.styles";

import LogoShipnow from "../../../../../assets/images/shipnow_logo_negro.svg";

const DEFAULT_PROPS = {
  center: false,
};

export const ShipnowLogo = (props) => {
  //? merge default attrs with attrs.
  const attrs = {
    ...DEFAULT_PROPS,
    ...props,
  };

  return (
    <Styles.Wrapper center={attrs.center} padding="b-20 t-80">
      <img alt="shipnow_logo" src={LogoShipnow} />
    </Styles.Wrapper>
  );
};

ShipnowLogo.propTypes = {
  center: PropTypes.bool,
};
